module.exports = __webpack_public_path__ + "static/media/ace-remote-interview.a5415839.png";